import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const InvoiceCardRoot = superstyled({
  name: 'PaymentReturnInvoiceCard',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.fixed.white,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 24,
    boxShadow: '0px 1px 2px 0px rgba(15,22,28,0.04), 0px 1.5px 3px -0.5px rgba(15,22,28,0.08)',
    overflow: 'hidden',
  }),
});
